import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { inspectionsTableChange } from './actions'

// function mapStateToProps(state) {
//     return {};
// }

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            inspectionsTableChange,
        },
        dispatch
    )
}

export default function (InnerComponent) {
    @connect(null, mapDispatchToProps)
    class HocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }
    return HocConnect
}
